module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "mine-box-title"
  }, [_c('a', {
    staticClass: "bc-od-back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goList($event)
      }
    }
  }, [_vm._v("← " + _vm._s(_vm.$T('返回订单列表')))]), _vm._v("\n    " + _vm._s(_vm.$T('订单详情')) + "\n  ")]), _vm._v(" "), (_vm.order.id) ? _c('div', {
    staticClass: "mine-content"
  }, [_c('div', {
    staticClass: "bc-od-status"
  }, [_c('div', {
    staticClass: "bc-od-status__name"
  }, [_vm._v(_vm._s(_vm.statusName))]), _vm._v(" "), (_vm.statusNote) ? _c('div', {
    staticClass: "bc-od-status__note"
  }, [_vm._v(_vm._s(_vm.statusNote))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bc-od-actions"
  }, _vm._l((_vm.actionButtons), function(btn, bi) {
    return _c('el-button', {
      key: 'a' + bi,
      attrs: {
        "size": "medium",
        "type": btn.class === 'primary' ? 'primary' : 'default'
      },
      on: {
        "click": function($event) {
          return _vm.onAction(btn)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.btnLabel(btn)) + "\n        ")])
  }), 1)]), _vm._v(" "), _c('section', {
    staticClass: "bc-od-card"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$T('收货信息')))]), _vm._v(" "), (_vm.order.address) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.order.address.name) + " " + _vm._s(_vm.order.address.phone || _vm.order.address.tel) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.order.address) ? _c('p', {
    staticClass: "gray"
  }, [_vm._v("\n        " + _vm._s(_vm.formatAddress(_vm.order.address)) + "\n      ")]) : _c('p', {
    staticClass: "gray"
  }, [_vm._v(_vm._s(_vm.$T('暂无地址信息')))])]), _vm._v(" "), _c('section', {
    staticClass: "bc-od-card"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$T('商品信息')))]), _vm._v(" "), _vm._l((_vm.order.items || []), function(g, gi) {
    return _c('div', {
      key: 'g' + gi,
      staticClass: "bc-od-goods"
    }, [_c('img', {
      attrs: {
        "src": g.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bc-od-goods__meta"
    }, [_c('div', {
      staticClass: "bc-od-goods__title"
    }, [_vm._v(_vm._s(g.title))]), _vm._v(" "), (_vm.skuText(g)) ? _c('div', {
      staticClass: "gray"
    }, [_vm._v(_vm._s(_vm.skuText(g)))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bc-od-goods__row"
    }, [_c('span', [_vm._v(_vm._s(_vm.money(g.price)))]), _vm._v(" "), _c('span', [_vm._v("× " + _vm._s(g.count))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "bc-od-sum"
  }, [_c('span', [_vm._v(_vm._s(_vm.$T('观众中心运费')) + "：" + _vm._s(_vm.money(_vm.order.express_price || 0)))]), _vm._v(" "), _c('span', [_vm._v("\n          " + _vm._s(_vm.$T('观众中心应付')) + "：\n          "), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.order.pay_price)))])])])], 2), _vm._v(" "), _c('section', {
    staticClass: "bc-od-card"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$T('订单信息')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$T('订单号')) + "：" + _vm._s(_vm.order.code || _vm.order.id))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$T('下单时间')) + "：" + _vm._s(_vm.order.create_time_str || _vm.formatTime(_vm.order.create_time)))]), _vm._v(" "), (_vm.order.pay_time_str && _vm.order.pay_time_str !== '-') ? _c('p', [_vm._v("\n        " + _vm._s(_vm.$T('支付时间')) + "：" + _vm._s(_vm.order.pay_time_str) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.order.pay_type) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.$T('支付方式')) + "：" + _vm._s(_vm.payTypeText(_vm.order.pay_type)) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.voucherPics.length) ? _c('div', {
    staticClass: "bc-od-voucher"
  }, [_c('div', {
    staticClass: "bc-od-voucher__label"
  }, [_vm._v(_vm._s(_vm.$T('付款凭证')))]), _vm._v(" "), _c('div', {
    staticClass: "bc-od-voucher__pics"
  }, _vm._l((_vm.voucherPics), function(pic, pi) {
    return _c('a', {
      key: 'p' + pi,
      attrs: {
        "href": _vm.picUrl(pic),
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.picUrl(pic),
        "alt": ""
      }
    })])
  }), 0)]) : _vm._e()])]) : _c('div', {
    staticClass: "mine-content bc-od-empty"
  }, [_vm._v(_vm._s(_vm.$T('观众中心加载中')))]), _vm._v(" "), _c('SpectatorOfflinePayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "ids": [_vm.order.id],
      "pay-price": _vm.order.pay_price
    },
    on: {
      "onPaid": _vm.onOfflinePaid,
      "onClose": function($event) {
        _vm.payDialogShow = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-606bcfec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/SpectatorOrderDetail.vue
// module id = 1482
// module chunks = 0